module.exports = __webpack_public_path__ + "media/images/emblems/Unterengstringen-blazon-920c8f8185a6e4fe7123108b22656bf6.svg";